import { render, staticRenderFns } from "./ActivaSolo.vue?vue&type=template&id=1a2ace61&scoped=true&"
import script from "./ActivaSolo.vue?vue&type=script&lang=js&"
export * from "./ActivaSolo.vue?vue&type=script&lang=js&"
import style0 from "./ActivaSolo.vue?vue&type=style&index=0&id=1a2ace61&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a2ace61",
  null
  
)

export default component.exports